import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ["form", "input"]

  connect() {
    this.inputTarget.blur()
  }

  autosave() {
    this.formTarget.requestSubmit()
  }

  checkReturn(event) {
    if (event.keyCode == 13 && this.inputTarget.dataset.blurOnReturn) {
      this.inputTarget.blur()
    }
  }
}
